import React, { useCallback } from "react";
import { useField } from "formik";

import { Checkbox, InputField, RadioField, SelectField } from "atoms";

export const FormInput = ({ name, validate, error: propError, ...props }) => {
  const [field, meta] = useField({ name, validate });
  const error = (meta.touched && meta.error) || propError || "";
  return (
    <InputField
      {...field}
      {...props}
      error={error}
      touched={meta.touched}
      value={meta.value || field.value}
    />
  );
};

export const FormSelect = ({
  name,
  options,
  validate,
  error: propError,
  ...props
}) => {
  const [field, meta, { setValue, setTouched }] = useField({ name, validate });

  const error =
    (meta.touched &&
      meta.error &&
      (typeof meta.error === "object"
        ? meta.error?.value || meta.error?.label
        : meta.error)) ||
    propError ||
    "";

  return (
    <SelectField
      {...field}
      value={
        Array.isArray(field.value)
          ? options?.filter((o) => field.value.includes(o.value))
          : // eslint-disable-next-line eqeqeq
            options?.find((o) => o.value == field.value) || field.value
      }
      {...props}
      onChange={(option) => {
        setValue(
          props?.isOptionLoadAsync
            ? option
            : Array.isArray(option)
            ? option?.map((o) => o?.value)
            : option?.value
        );
        if (props.onChange) {
          props.onChange(
            props?.isOptionLoadAsync
              ? option
              : Array.isArray(option)
              ? option?.map((o) => o?.value)
              : option?.value
          );
        }
      }}
      onBlur={(e) => {
        setTouched(true);
        if (props.onBlur) {
          props.onBlur(e);
        }
      }}
      options={options}
      error={error}
      isSearchable
    />
  );
};

export const FormRadio = ({
  name,
  onChange: onChangeFromProps,
  value,
  ...props
}) => {
  const [field, , { setValue }] = useField(name);

  const onChange = useCallback(
    (e) => {
      // e.currentTarget.blur();
      setValue(value);
      if (typeof onChangeFromProps === "function") {
        onChangeFromProps(value);
      }
    },
    [setValue, onChangeFromProps, value]
  );

  return (
    <RadioField
      {...field}
      value={value}
      checked={field.value === value}
      {...props}
      onChange={onChange}
    />
  );
};

export const FormCheckbox = ({
  name,
  onChange: onChangeFromProps,
  value,
  isMulti = true,
  ...props
}) => {
  const [field, , { setValue, setTouched }] = useField(name);

  const onChange = useCallback(
    (e) => {
      let newValue = JSON.parse(JSON.stringify(field.value)) || [];

      switch (isMulti) {
        case true: {
          if (e.target.checked) {
            const currIndex = newValue?.indexOf(value);
            currIndex < 0 && newValue.push(value);
          } else {
            const currIndex = newValue?.indexOf(value);
            newValue = [
              ...newValue.slice(0, currIndex),
              ...newValue.slice(currIndex + 1),
            ];
          }
          break;
        }
        case false: {
          if (e.target.checked) {
            newValue = [value];
          } else {
            newValue = [];
          }
          break;
        }

        default: {
          break;
        }
      }

      setValue(newValue);
      setTouched(true);

      if (typeof onChangeFromProps === "function") {
        onChangeFromProps(e?.target?.checked);
      }
    },
    [setValue, setTouched, onChangeFromProps, value, field.value, isMulti]
  );

  return (
    <Checkbox
      {...field}
      checked={field.value?.indexOf(value) > -1}
      {...props}
      onChange={onChange}
    />
  );
};

// export const FormOtpInput = ({
//   name,
//   error: propError,
//   onChange: onChangeFromProps,
//   ...props
// }) => {
//   const [field, meta, { setValue }] = useField({ name });

//   const error = (meta.touched && meta.error) || propError || "";

//   const onChange = useCallback(
//     (val) => {
//       setValue(val);
//       if (typeof onChangeFromProps === "function") {
//         onChangeFromProps(val);
//       }
//     },
//     [setValue, onChangeFromProps]
//   );

//   return (
//     <Box position="relative">
//       <OtpInput {...field} {...props} onChange={onChange} hasError={!!error} />
//       {error && (
//         <Error mt="0.8rem" text={error} fontSize="1.2rem" lineHeight="1.4rem" />
//       )}
//     </Box>
//   );
// };
